import React, { useEffect, useState } from 'react';
const DynamicImage = ({ kitTitle, baseImage, currentBundle, imagesCache }) => {
    const [variantImageURLs, setVariantImageURLs] = useState([]);
    useEffect(() => {
        const imageUrlSplit = baseImage.split('_base');
        if (currentBundle.colours) {
            const variantURLArray = [];
            if (currentBundle.colours.length == 1) {
                const imageURL = imageUrlSplit.join(`_colour_${currentBundle.colours[0].handle}`);
                variantURLArray.push({ image: `${imageURL}_${imagesCache}`, name: currentBundle.colours[0].handle });
            }
            else {
                currentBundle.colours.forEach((colour, index) => {
                    const imageURL = imageUrlSplit.join(`_colour-${index + 1}_${colour.handle}`);
                    variantURLArray.push({ image: `${imageURL}_${imagesCache}`, name: colour.handle });
                });
            }
            setVariantImageURLs(variantURLArray);
        }
    }, [currentBundle]);
    useEffect(() => {
        // Bundle loaded
        const skeletons = document.querySelectorAll('.bundle-skeleton-image');
        const base_images = document.querySelectorAll('#bundle-dynamic-flow-image');
        if (skeletons) {
            skeletons.forEach((skeleton) => skeleton.classList.add('bundle-skeleton-hide'));
            base_images.forEach((imageContainer) => imageContainer.classList.remove('bundle-loading'));
        }
    }, []);
    const getMobileImage = (imageURL) => {
        return imageURL.split('680x680').join('300x300');
    };
    return (React.createElement("div", { className: "dynamic-image" },
        React.createElement("picture", null,
            React.createElement("source", { type: "image/png", media: "(min-width: 768px)", "data-srcset": baseImage }),
            React.createElement("source", { type: "image/png", media: "(max-width: 767px)", "data-srcset": getMobileImage(baseImage) }),
            React.createElement("img", { loading: "lazy", src: baseImage, alt: kitTitle })),
        variantImageURLs.map((imageURL, index) => (React.createElement("picture", { key: `image-url--${index}` },
            React.createElement("source", { type: "image/png", media: "(min-width: 768px)", "data-srcset": imageURL.image }),
            React.createElement("source", { type: "image/png", media: "(max-width: 767px)", "data-srcset": getMobileImage(imageURL.image) }),
            React.createElement("img", { loading: "lazy", src: imageURL.image, alt: imageURL.name }))))));
};
export default DynamicImage;
